import { render, staticRenderFns } from "./addqualification.vue?vue&type=template&id=3db65781"
import script from "./addqualification.js?vue&type=script&lang=js&external"
export * from "./addqualification.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports